import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd, ActivatedRoute, RouterModule } from '@angular/router';
import { HlmBreadcrumbImports } from '@spartan-ng/helm/breadcrumb';
import { filter, map, startWith } from 'rxjs';

interface BreadcrumbItem {
  label: string;
  url: string;
}

@Component({
  imports: [RouterModule, HlmBreadcrumbImports],
  selector: 'app-breadcrumb',
  template: `
    <nav hlmBreadcrumb>
      <ol hlmBreadcrumbList>
        @for(item of breadcrumbs(); track $index; let last = $last){
          @if(!last){
            <li hlmBreadcrumbItem>
              <span>{{item.label}}</span>
            </li>
            <li hlmBreadcrumbSeparator></li>
          }@else{
            <li hlmBreadcrumbItem>
              <span hlmBreadcrumbPage>{{item.label}}</span>
            </li>
          }
        }
      </ol>
    </nav>
  `,
})
export class Breadcrumb {

  private readonly router = inject(Router);

  protected breadcrumbs = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      startWith(null),
      map(() => this.buildBreadcrumbs(this.router.routerState.root))
    ),
    { requireSync: true }
  );

  private buildBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: BreadcrumbItem[] = []): BreadcrumbItem[] {
    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }
    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }
      const label = child.snapshot.data['title'];
      if (label) {
        breadcrumbs.push({ label, url });
      }
      return this.buildBreadcrumbs(child, url, breadcrumbs);
    }
    return breadcrumbs;
  }
}

